import { Link } from 'react-router-dom';
const FlightTabs = (props) => {
    return (
        <ul className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3" role="tablist">
            <li className="nav-item" role="presentation">
                <Link to={"/flight/search"} className={props.pageName === "SEARCH" ? "nav-link active bg-primary text-white" : "nav-link"}>SEARCH</Link>
            </li>
            <li className="nav-item" role="presentation">
                <Link to={"/flight/bookings"} className={props.pageName === "FLIGHTBOOKING" ? "nav-link active bg-primary text-white" : "nav-link"}>BOOKINGS</Link>
            </li>
            <li className="nav-item" role="presentation">
                <Link to={"/groupbookings"} className={props.pageName === "GROUPFLIGHT" ? "nav-link active bg-primary text-white" : "nav-link"}>GROUP BOOKINGS</Link>
            </li>
            <li className="nav-item" role="presentation">
                <Link to={"/flightreport"} className={props.pageName === "FLIGHTREPORT" ? "nav-link active bg-primary text-white" : "nav-link"}>FLIGHT REPORT</Link>
            </li>
        </ul>
    );
};

export default FlightTabs;
